var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isLoading)?_c('Loading'):_c('div',{attrs:{"id":"app-root"}},[_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }